import { render, staticRenderFns } from "./TeachingNewDialog.vue?vue&type=template&id=2d3abab1"
import script from "./TeachingNewDialog.vue?vue&type=script&lang=js"
export * from "./TeachingNewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports